import React from 'react';

import { ReactComponent as CloseIcon } from "../../svg/close-icon.svg";
import * as Styled from './PreSaleOverlay.styles';
import { pageMotionProps } from 'utils/styles/animations';
import GradientLine from 'components/GradientLine/GradientLine';
import useGlobalStore from 'utils/store';
import Counter from 'components/Counter/Counter';
import ButtonCta from 'components/ButtonCta/ButtonCta';
import ButtonClean from 'components/ButtonClean/ButtonClean';
import gsap from 'gsap';

export interface PreSaleOverlayProps {
  onClose: () => void,
}

const PreSaleOverlay: React.FC<PreSaleOverlayProps> = ({onClose}) => {
  const { sceneMounted, copy, isPreVenda } = useGlobalStore();
  const contentRef = React.useRef<HTMLDivElement>(null);
  return <Styled.Wrapper id="pre-sale" {...pageMotionProps} >
    
    <Styled.Content ref={contentRef} className={sceneMounted ? "fadeIn" : ""}>
    <Styled.CloseWrapper>
      <CloseIcon onClick={() => {
          
          contentRef.current?.classList.remove("fadeIn");
          contentRef.current?.classList.add("fadeOut");
          setTimeout(() => {
            onClose();
          }, 500);
        }}/>
    </Styled.CloseWrapper>
      
      <Styled.ContentTitle dangerouslySetInnerHTML={{__html: copy.preSale.title}} />
      <Counter />
      <Styled.ContentHeader>
        <span>{new Date(copy.preSale.date).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }).replace(/\//g, '.')}</span>
      </Styled.ContentHeader>
    </Styled.Content>

  </Styled.Wrapper>;
};

export default PreSaleOverlay;
